import { useEffect, useState } from 'react'
import { useIdleTimer as idleTimer } from 'react-idle-timer'


const TIME_MULTIPLIER = 1000

const TIMEOUT = parseInt(process.env.REACT_APP_IDLE_TIMEOUT, 14) * TIME_MULTIPLIER * 60
const PROMPT_TIMEOUT = 1 * TIME_MULTIPLIER * 60

interface IdleTimerHook {
  prompted: boolean;
  remainingTime: number;
  closePrompt: () => void;
  activate: () => void;
}

const useIdleTimer = (onIdle: () => void): IdleTimerHook => {
  const [prompted, setPrompted] = useState<boolean>(false)
  const onPrompt = () => {
    setPrompted(true)
  }

  const {
    activate,
    getRemainingTime,
    ...rest
  } = idleTimer({
    onIdle,
    onPrompt,
    timeout: TIMEOUT,
    promptBeforeIdle: PROMPT_TIMEOUT,
    events: ['keydown', 'wheel', 'DOMMouseScroll', 'mousewheel', 'mousedown', 'touchstart', 'touchmove', 'MSPointerDown', 'MSPointerMove'],
    debounce: 500,
    eventsThrottle: 200,
    crossTab: true,
    name: 'idle-timer',
    syncTimers: 1,
    leaderElection: false,
  })

  const [remainingTime, setRemainingTime] = useState<number>(PROMPT_TIMEOUT / TIME_MULTIPLIER)

  useEffect(() => {
    let interval: NodeJS.Timeout

    if (prompted) {
      interval = setInterval(() => {
        const remaining = Math.ceil(getRemainingTime() / TIME_MULTIPLIER)

        // Close prompt to allow multiple tabs
        if (remaining > PROMPT_TIMEOUT / TIME_MULTIPLIER) {
          setPrompted(false)
        }

        setRemainingTime(remaining)
      }, 1000)
    }
    return () => interval && clearInterval(interval)
  }, [prompted])

  const closePrompt = () => {
    setPrompted(false)
    activate()
  }

  return {
    prompted,
    remainingTime,
    closePrompt,
    activate,
    ...rest,
  }
}

export default useIdleTimer
